import React, { Component } from 'react';
import {
  View,
  Text,
  ScrollView,
  Easing,
  TouchableHighlight,
  Animated,
  TextInput,
  Dimensions,
  FlatList,
  Platform, 
  ActivityIndicator,
  Image,
  Alert,
} from 'react-native';
import {StyleContext,styleInfo} from '../styleC';
import { NavigationActions } from './react-navigation'; // Version can be specified in package.json
import firebase from './firebase';
import { getAuth } from "firebase/auth";
import info from '../info';
import { getDatabase, set, ref, update, remove, get, onValue, child, orderByChild, orderByValue, limitToFirst, startAt, endAt, query} from "firebase/database";
import { getStorage, ref as refStorage, uploadBytes  } from "firebase/storage";
import strings from '../strings';
import MavAlert from './mavAlert';
import MavButton from './mavButton';
import moneyList from '../moneyList';
import Modal from './modal';
import RNFetchBlob from './RNFetchBlob';
import ImagePick from './imagePicker';
import TextPresentation from './textPresentation';
import MavInfoBubble from './mavInfoBubble';
import MavMiniButton from './mavMiniButton';
const timer = require('react-native-timer');





export default class account extends Component {
  constructor(props) {
    super(props);

    var infoMoney=this.findMoney();
    var params=(this.props.route!=undefined)?this.props.route.params:this.props.params;

    var picturesCar={carAvailable:{  default:{source:require('../assets/car.png')} }  }
    if(params.picturesCar!=undefined && params.picturesCar.carAvailable!=undefined){
      var objPCCA=Object.keys(params.picturesCar.carAvailable); 
      var i;
      for(i=0; i<objPCCA.length;i++){

        picturesCar.carAvailable[objPCCA[i]]={source: {uri:"https://firebasestorage.googleapis.com/v0/b/"+info.firebaseProjectID+".appspot.com/o/assets%2F"+objPCCA[i]+"%2Fpicture.png?alt=media"}      }
      }
    }

    if(params.picturesCar!=undefined && params.picturesCar.carUsed!=undefined){
      var objPCCA=Object.keys(params.picturesCar.carUsed); 
      var i;
      if(objPCCA.length>0) picturesCar.carUsed={}
      for(i=0; i<objPCCA.length;i++){
        picturesCar.carUsed[objPCCA[i]]={above:params.picturesCar.carUsed[objPCCA[i]], aboveSource: {uri:"https://firebasestorage.googleapis.com/v0/b/"+info.firebaseProjectID+".appspot.com/o/assets%2F"+params.picturesCar.carUsed[objPCCA[i]].above+"%2Fpicture.png?alt=media"}      }
      }
    }


    this.state = {
      vipMode:params.vipMode, 
      extraEUMode:params.extraEUMode,
      carList:{}, 
      moneyList:{},
      money:infoMoney,
      seeDetail:false, 
      selectedElement:"fr",
      optionalOrder:params.optionalOrder,
      optionalOrderSave:(params.optionalOrder!=undefined)?JSON.parse(JSON.stringify(params.optionalOrder)):undefined,
      loadPicture:false, 

      viewCarMode:(params.viewCarMode==true)?true:false,
      viewRealDriverForDriver:params.viewRealDriverForDriver,
      viewRealDriver:params.viewRealDriver,
      hideOtherCarIfRaceInProgress:params.hideOtherCarIfRaceInProgress,
      driverPositionPrecise:(params.driverPositionPrecise!=undefined)?params.driverPositionPrecise:false,
      carDriverColor:params.carDriverColor,
      driverApproachingColor:params.driverApproachingColor, 
      viewAboveCar:false, 
      picturesCar:picturesCar, 
      picturesCarClassic:params.picturesCar, 
      
    };
  }


  
  componentDidMount() {

    this.getAllCar()
    

  }




  updatePictureCar(info){

      var picturesCar=this.state.picturesCar;
      var picturesCarClassic=this.state.picturesCarClassic;
      if(picturesCarClassic==undefined) picturesCarClassic={}; 
      if(info.type=="addCar"){
        if(picturesCar.carAvailable==undefined) picturesCar.carAvailable={}; 
        picturesCar.carAvailable[info.uuid]={source:{uri:"https://firebasestorage.googleapis.com/v0/b/"+info.firebaseProjectID+".appspot.com/o/assets%2F"+info.uuid+"%2Fpicture.png?alt=media"} }
        if(picturesCarClassic.carAvailable==undefined) picturesCarClassic.carAvailable={};
        picturesCarClassic.carAvailable[info.uuid]=true;
        
      }
      else if(info.type=="modifyAboveCar"){
        if(picturesCar.carUsed==undefined) picturesCar.carUsed={}
        if(picturesCar.carUsed[this.state.selectedAboveCar]==undefined) picturesCar.carUsed[this.state.selectedAboveCar]={};
        picturesCar.carUsed[this.state.selectedAboveCar].above=info.uuidCar
        picturesCar.carUsed[this.state.selectedAboveCar].aboveSource={uri:"https://firebasestorage.googleapis.com/v0/b/"+info.firebaseProjectID+".appspot.com/o/assets%2F"+picturesCar.carUsed[this.state.selectedAboveCar].above+"%2Fpicture.png?alt=media"}

        if(picturesCar.carUsed[this.state.selectedAboveCar].above=="default"){
          delete picturesCar.carUsed[this.state.selectedAboveCar].above; 
          delete picturesCar.carUsed[this.state.selectedAboveCar].aboveSource; 
        }



        if(picturesCar.carUsed[this.state.selectedAboveCar]!=undefined){
          if(picturesCarClassic.carUsed==undefined) picturesCarClassic.carUsed={};
          if(picturesCarClassic.carUsed[this.state.selectedAboveCar]==undefined) picturesCarClassic.carUsed[this.state.selectedAboveCar]={}
          picturesCarClassic.carUsed[this.state.selectedAboveCar].above=picturesCar.carUsed[this.state.selectedAboveCar].above;
          if(picturesCarClassic.carUsed[this.state.selectedAboveCar].above==undefined) delete picturesCarClassic.carUsed[this.state.selectedAboveCar]
          

        } else if(picturesCarClassic.carUsed!=undefined && picturesCarClassic.carUsed[this.state.selectedAboveCar].above!=undefined) delete picturesCarClassic.carUsed[this.state.selectedAboveCar].above; 
       

          
      }
      console.log("picturesCarClassic")
      console.log(picturesCarClassic)
      this.setState({picturesCar:picturesCar, picturesCarClassic:picturesCarClassic})
      var params=(this.props.route!=undefined)?this.props.route.params:this.props.params;
      params.updatePicturesCar(picturesCarClassic)






  }



  takePicture(){
    
    console.log("take picture mount")
    var options = {imageFileType: 'png', title: strings.selectPicture,chooseFromLibraryButtonTitle:strings.library, takePhotoButtonTitle:strings.camera,cancelButtonTitle:strings.cancel,storageOptions: {skipBackup: true,path: 'images',quality:0.5}};


    ImagePick.launchImageLibrary(options, (response) => {
      if (response.didCancel) {console.log('User cancelled image picker');}else if (response.error) {console.log('ImagePicker Error: ', response.error);}else if (response.customButton) {console.log('User tapped custom button: ', response.customButton);}
      else {
       const image = Platform.OS === 'ios' ? response.assets[0].uri.replace('file://', '') : response.assets[0].uri
 
        const Blob = RNFetchBlob.polyfill.Blob
        const fs = RNFetchBlob.fs
        window.XMLHttpRequest = RNFetchBlob.polyfill.XMLHttpRequest
        window.Blob = Blob
 
        this.setState({loadPicture:true})

        let uploadBlob = null
        var uuid=generateUUID();
        console.log("jenvoi la picture")
        const imageRef = refStorage(getStorage(), 'assets/'+uuid+'/picture.png');
        let mime = 'image/png'
        fs.readFile(image, 'base64')
        .then((data) => {
          return Blob.build(data, { type: `${mime};BASE64` })
        })
        .then((blob) => {
          uploadBlob = blob
          console.log("blob info")
          console.log(blob)
          return uploadBytes(imageRef, blob)
          })
        .then(() => {
          uploadBlob.close()
          console.log("blob fini appel à updatePictureCar")
          this.updatePictureCar({type:"addCar", uuid:uuid })

          this.setState({loadPicture:false}); 
          return getDownloadURL(imageRef)
        })
        .catch((error) => {
          this.alert.onAlert({title:strings.errorDefault})
           this.setState({loadPicture:false})
           console.log("error pict")
          console.log(error);
 
        })  

    }
    });

    
     
  }
  


  updateColor(color){


      
      let reg = /^#[0-9A-F]{6}$/i;
      if(reg.test(color)!=true){ this.alert.onAlert({title:strings.invalidColorCode,}) }
      else {
          color="rgba("+parseInt((color[1]+color[2]), 16)+","+parseInt((color[3]+color[4]), 16)+","+parseInt((color[5]+color[6]), 16)+",0.3)";
          var params=(this.props.route!=undefined)?this.props.route.params:this.props.params;

          if(this.state.colorSelected=="carDriverColor"){
            this.setState({carDriverColor:color})
            params.updateColorDriver("carDriverColor",color)
          }
          else {
             this.setState({driverApproachingColor:color})
            params.updateColorDriver("driverApproachingColor",color)
          }

      }

      
      

      

  }



  findMoney(value){
    if(value==undefined) value="eu";
    var final="";
    var i;
    for(i=0;i<moneyList.length;i++){
      if(final==""){
        if(moneyList[i].id==value) final=moneyList[i];
      }
    }
    return final
  }


  getAllCar(){
    get(child(ref(getDatabase(firebase)), '/pricing')).then(value => {
        var moneyIDList={};
        var val1=value.val();
        var val1array=Object.keys(val1)
        get(child(ref(getDatabase(firebase)), '/pricingProvision')).then(value2 => {
          var val2=value2.val();
          var carList={};
          var i,j,pr,pra;
          if(val1!=null){
            for(i=0;i<val1array.length;i++){
                pr=val1[val1array[i]].price;
                pra=Object.keys(pr)
                for(j=0;j<pra.length;j++){
                    var name=pr[pra[j]].name;
                    if(pr[pra[j]].moneyID!=undefined) moneyIDList[pr[pra[j]].moneyID]=true; 
                    if(val1[val1array[i]].taxiMode==true) name="TAXI - "+name;
                    
                    carList[name]=false;


                } 
            }

          }
          if(val2!=null){
            var val2array=Object.keys(val2)
            for(i=0;i<val2array.length;i++){
              if(val2array[i]=="typeZone"){
                  var k,l;
                  var tttot=val2[val2array[i]]; 
                  for(k=0;k<tttot.length;k++){
                      if(tttot[k].moneyID!=undefined) moneyIDList[tttot[k].moneyID]=true;
                      var listTttot=Object.keys(tttot[k].price)
                      for(l=0;l<listTttot.length;l++){
                          carList[tttot[k].price[listTttot[l]].name]=false
                      }
                  }
              }
              else{
                  carList[val2[val2array[i]].name]=false;
                  if(val2[val2array[i]].moneyID!=undefined) moneyIDList[val2[val2array[i]].moneyID]=true;
              }
            }  
          }
          var allCar=this.state.carList
          if(allCar!={}){
            var cla=Object.keys(this.state.carList);
            for(i=0;i<cla.length;i++){
              if(carList[cla[i]]!=undefined) carList[cla[i]]=allCar[cla[i]]
            }
          }
          this.setState({carList:carList})

          if(this.state.extraEUMode==true && (Object.keys(moneyIDList).length>1 || (Object.keys(moneyIDList).length==1 && moneyIDList["eu"]!=true)) ){
              
              if(moneyIDList["eu"]!=true) {
                var infoMoney=this.findMoney(Object.keys(moneyIDList)[0]);
                this.setState({money:infoMoney})
              }
              else{
                var k;
                var moneyListInfo=[];
                for(k=0; k<moneyList.length;k++){
                  if( moneyIDList[ moneyList[k].id ] ===true ){
                    moneyListInfo.push(moneyList[k])
                  }
                }

                this.setState({moneyList:moneyListInfo})
              }


          }

         }) 

       }) 

  }


  updateOption(rowData, position, urlImage){

    var i; 

    var opt=JSON.parse(JSON.stringify(this.state.optionalOrder)) 
    console.log(this.state.optionalOrderSave)

    if(this.state.optionalOrder[rowData].name["fr"]=="" || this.state.optionalOrder[rowData].name["fr"]==undefined ) this.alert.onAlert({title:strings.thankWriteName})
    else{
        
        
      
        /*si j'ai une image et que différent de celle d'avant*/
        if(opt[rowData].picture!=undefined && opt[rowData].changePicture==true && urlImage==undefined){

          if(this.state.optionalOrderSave!=undefined && this.state.optionalOrderSave[rowData]!=undefined && this.state.optionalOrderSave[rowData].picture!=undefined){

            var elemSup=JSON.parse(JSON.stringify(this.state.optionalOrderSave[rowData].picture));

            /*je supprime l'ancienne image*/
            getAuth(firebase).currentUser.getIdToken().then(token => {

              var bodyRemove={bundleIdentifer:info.bundleIdentifer,dataType:elemSup.dataType, bundleAdress:info.firebaseProjectID,token:token,userID:getAuth(firebase).currentUser.uid,uuid:elemSup.uuid,}
              if(Platform.OS=="web") fetch('https://52ea3f3.online-server.cloud/remove',{method: 'POST',headers: {'Content-Type': 'application/json',}, body: JSON.stringify(bodyRemove)})
              else RNFetchBlob.fetch('POST','https://52ea3f3.online-server.cloud/remove',{ 'Content-Type': 'application/json'},JSON.stringify(bodyRemove)).then(response => { console.log(response) })


            })

          }


          /*j'envoi l'image*/

          getAuth(firebase).currentUser.getIdToken().then(token => {

            var bodyInfo={
                bundleIdentifer:info.bundleIdentifer,
                bundleAdress:info.firebaseProjectID,
                token:token,
                userID:getAuth(firebase).currentUser.uid,
                data:opt[rowData].picture.data,
                pictureUsage:"option",
                dataType:opt[rowData].picture.dataType,
            }
            if(Platform.OS=="web") fetch('https://52ea3f3.online-server.cloud/upload',{method: 'POST',headers: {'Content-Type': 'application/json',}, body: JSON.stringify(bodyInfo)}).then((response) => response.json()).then((data) => { if(typeof(data)=="string") data=JSON.parse(data);  this.updateOption(rowData, position, data) })
            else RNFetchBlob.fetch('POST','https://52ea3f3.online-server.cloud/upload',{ 'Content-Type': 'application/json'},JSON.stringify(bodyInfo)).then(response => {if(typeof(response.data)=="string") response.data=JSON.parse(response.data);  this.updateOption(rowData, position, response.data) })




        })


          

        }


        else {
          /*je supprime le notSave*/
            delete opt[rowData].notSaved;


              var priceFinal={}
               if(opt[rowData].price!=undefined){
                  var priceArray=Object.keys(opt[rowData].price)
                  for(i=0; i<priceArray.length;i++){
                      if(opt[rowData].price[priceArray[i]]!=""){
                        opt[rowData].price[priceArray[i]]=parseFloat(opt[rowData].price[priceArray[i]])
                        if(!isNaN(opt[rowData].price[priceArray[i]])) priceFinal[priceArray[i]]=opt[rowData].price[priceArray[i]]
                      }
                  }
              }
              opt[rowData].price=priceFinal;
              if(opt[rowData].description==undefined || !(Object.keys(opt[rowData].description).length>0)) delete opt[rowData].description;



              if(opt[rowData].picture!=undefined && opt[rowData].changePicture==true){
                delete opt[rowData].changePicture; 

                opt[rowData].picture={
                  dataType:opt[rowData].picture.dataType, 
                  name:opt[rowData].picture.name,
                  uuid:urlImage.uuid,
                  url:urlImage.url,
                }
              }

              if(this.state.vipMode==true &&  opt[rowData].target==undefined)  opt[rowData].target={standard:true, vip:true, pro:true};
              if(opt[rowData].index==undefined) {opt[rowData].index=Object.keys(this.state.optionalOrderSave).length; this.setState({addOptionSelected:false}) }

              var sendSave=JSON.parse(JSON.stringify(this.state.optionalOrderSave))
              sendSave[rowData]=JSON.parse(JSON.stringify(opt[rowData]));

              var params=(this.props.route!=undefined)?this.props.route.params:this.props.params; 
              params.updateOptionalOrder(sendSave);
              

              

              /*opt[rowData]=this.state.optionalOrder[rowData]; */

              this.setState({optionalOrderSave:sendSave, optionalOrder:opt})
             

              this['viewOption_' + position].close(); 

      }

    }

  }

 removeOption(rowData, position){
    var opt=JSON.parse(JSON.stringify(this.state.optionalOrder))
    if(this.state.optionalOrder[rowData].index==undefined){
        delete opt[rowData]; 
        this.setState({optionalOrder:opt, addOptionSelected:false}); 
    } else{
          this['viewOption_' + position].close(); 

          if(this.state.optionalOrderSave!=undefined && this.state.optionalOrderSave[rowData]!=undefined && this.state.optionalOrderSave[rowData].picture!=undefined){

            var elemSup=JSON.parse(JSON.stringify(this.state.optionalOrderSave[rowData].picture));

            /*je supprime l'ancienne image*/
            getAuth(firebase).currentUser.getIdToken().then(token => {
              
              var bodyRemove={bundleIdentifer:info.bundleIdentifer,dataType:elemSup.dataType, bundleAdress:info.firebaseProjectID,token:token,userID:getAuth(firebase).currentUser.uid,uuid:elemSup.uuid,}
              if(Platform.OS=="web") fetch('https://52ea3f3.online-server.cloud/remove',{method: 'POST',headers: {'Content-Type': 'application/json',}, body: JSON.stringify(bodyRemove)})
              else RNFetchBlob.fetch('POST','https://52ea3f3.online-server.cloud/remove',{ 'Content-Type': 'application/json'},JSON.stringify(bodyRemove)).then(response => {  })


            })

          }

          var optSave=JSON.parse(JSON.stringify(this.state.optionalOrderSave))
          delete optSave[rowData];
          delete opt[rowData]; 

          var optionalOrderArray=Object.keys(optSave).sort((a,b)=>{ return optSave[a].index-optSave[b].index} )
          var i; 
          for(i=0; i<optionalOrderArray.length;i++){
            opt[optionalOrderArray[i]].index=i; 
            optSave[optionalOrderArray[i]].index=i; 
            
          }
          var params=(this.props.route!=undefined)?this.props.route.params:this.props.params; 
          params.updateOptionalOrder(optSave);
          this.setState({optionalOrderSave:optSave, optionalOrder:opt})


    }

 }


  viewTarget = (rowData) => {
      var list=[];
      var i;
      if(this.state.vipMode==true){
          list.push({text:strings.standard, id:i, selected:(this.state.optionalOrder[rowData].target==undefined || this.state.optionalOrder[rowData].target.standard!=false)?true:false })
          list.push({text:strings.vip, id:i, selected:(this.state.optionalOrder[rowData].target==undefined || this.state.optionalOrder[rowData].target.vip!=false)?true:false })
          list.push({text:strings.pro, id:i, selected:(this.state.optionalOrder[rowData].target==undefined || this.state.optionalOrder[rowData].target.pro!=false)?true:false })
          list.push({text:strings.onlyAdmin, id:i, onlySelected:true, selected:(this.state.optionalOrder[rowData].onlyAdmin!=undefined && this.state.optionalOrder[rowData].target.onlyAdmin==true)?true:false })
      } else {
          list.push({text:strings.all,  selected:(this.state.optionalOrder[rowData].onlyAdmin==true)?false:true, onlySelected:true })
          list.push({text:strings.onlyAdmin,  selected:(this.state.optionalOrder[rowData].onlyAdmin==true)?true:false, onlySelected:true})
      }
      

      this.alert.onAlert({title:strings.target, subTitle:strings.selectUsersOption, items:list,multiSelected:true,onlySelectedOption:true, buttons:[{text: strings.validate,onPress: (list) => {
          var opt=this.state.optionalOrder; 
          if(this.state.vipMode==true){
            opt[rowData].target={standard:(list[0].selected==true)?true:false, vip:(list[1].selected==true)?true:false, pro:(list[2].selected==true)?true:false,}
            if(list[3].selected==true) opt[rowData].onlyAdmin=true
            else delete opt[rowData].onlyAdmin;
          } else {
              if(list[1].selected==true) opt[rowData].onlyAdmin=true
              else delete opt[rowData].onlyAdmin;
          }

          opt[rowData].notSaved=true; 
          this.setState({optionalOrder:opt})      

      }},{text: strings.cancel, style:"cancel",onPress: () => {}}] })  

     
  }




  viewCarList = (rowData) => {
      var list=[];
      var i;
      var listCar=Object.keys(this.state.carList)
      for(i=0;i<listCar.length;i++){
          
          list.push({text:listCar[i], id:i, selected:(this.state.optionalOrder[rowData].carList!=undefined && this.state.optionalOrder[rowData].carList[listCar[i]]==true)?true:false })
      

      }
                            
      this.alert.onAlert({title:strings.cars, subTitle:strings.targetCarMoreInfo, items:list,multiSelected:true, buttons:[{text: strings.validate,onPress: (list) => {
          var opt=this.state.optionalOrder; 
          opt[rowData].carList={}
          for(i=0;i<list.length;i++){
            if(list[i].selected==true) opt[rowData].carList[list[i].text]=true; 
          }

          opt[rowData].notSaved=true; 
          this.setState({optionalOrder:opt})      

      }},{text: strings.cancel, style:"cancel",onPress: () => {}}] })  



  }

   viewRepartition = (rowData) => {
      var list=[{id:"share", text:strings.priceShare, help:strings.priceShareMoreInfo}, {id:"forDriver", text:strings.forDriver, help:strings.forDriverMoreInfo},{id:"forPlatform", text:strings.forPlatform, help:strings.forPlatformMoreInfo} ];
      
                            
      this.alert.onAlert({title:strings.repartition, subTitle:strings.repartitionOptionsMoreInfo,help:{title:strings.priceShare, subTitle:strings.priceShareMoreInfo, }, items:list, itemSelected:(this.state.optionalOrder[rowData].repartition==undefined)?0:( (this.state.optionalOrder[rowData].repartition=="forDriver")?1:2 ) ,buttons:[{text: strings.validate,onPress: (result) => {
          var opt=this.state.optionalOrder; 
          opt[rowData].repartition=(result==0)?undefined:( (result==1)?"forDriver":"forPlatform" );
          
          opt[rowData].notSaved=true; 
          this.setState({optionalOrder:opt})      

      }},{text: strings.cancel, style:"cancel",onPress: () => {}}] })  




}




  

  render() {
    let moneyListTotal=moneyList

    return (
      <StyleContext.Consumer>{style => 
      <ScrollView style={{flex:1,backgroundColor:style.backgroundColor}}>


        {(this.state.updateValue!=true && this.state.optionalOrder!=undefined) && <View>

              <MavInfoBubble type={"menu"} icon={(style.mode=="dark")?require('../assets/luggage_white.png'):require('../assets/luggage_black.png')} title={strings.yourOptions} subTitle={strings.yourOptionsMoreInfo}  style={{marginTop:10,marginBottom:20}} />
              {true && <MavInfoBubble type={"help"} videoLink={"https://www.youtube.com/watch?v=XBV29fqYyZQ"} tutdoLink={"http://www.google.fr"} style={{marginTop:0,marginBottom:20}} />}
        
              {Object.keys(this.state.optionalOrder).sort((a,b)=>{ return this.state.optionalOrder[a].index-this.state.optionalOrder[b].index} ).map((rowData,i) => (
                 <TextPresentation ref={viewOption => {this['viewOption_' + i] = viewOption;}} textMini={(this.state.optionalOrder[rowData].notSaved==true)?strings.notSaved:undefined} text={(this.state.optionalOrder[rowData].name[strings.idLangue]!=undefined)?this.state.optionalOrder[rowData].name[strings.idLangue]:( (this.state.optionalOrder[rowData].name["fr"]!=undefined && this.state.optionalOrder[rowData].name["fr"]!="")?this.state.optionalOrder[rowData].name["fr"]:strings.noNameOption )} style={{marginTop:5}} icon={((style.mode=="dark")?require('../assets/luggage_white.png'):require('../assets/luggage_black.png'))}    >
                    
                      <TextPresentation textExplicationSmall={strings.defineNameOption} text={(this.state.optionalOrder[rowData].name!=undefined && this.state.optionalOrder[rowData].name[this.state.selectedElement]!=undefined)?this.state.optionalOrder[rowData].name[this.state.selectedElement]:""} textExplication={strings.lastName}  placeholder={strings.lastName} chooseLanguage={this.state.selectedElement} onChangeLanguage={(value)=>{   this.setState({selectedElement:value}) }} onChangeText={(text)=>{  var opt=this.state.optionalOrder; if(opt[rowData].name==undefined) opt[rowData].name={}; opt[rowData].notSaved=true; opt[rowData].name[this.state.selectedElement]=text; this.setState({optionalOrder:opt})      }}   />
                      <TextPresentation  text={(this.state.optionalOrder[rowData].description!=undefined && this.state.optionalOrder[rowData].description[this.state.selectedElement]!=undefined)?this.state.optionalOrder[rowData].description[this.state.selectedElement]:""}  textExplication={strings.description} multiline={true}  placeholder={strings.descriptionMoreOptionEx}  onChangeText={(text)=>{  var opt=this.state.optionalOrder; if(opt[rowData].description==undefined) opt[rowData].description={}; opt[rowData].notSaved=true; opt[rowData].description[this.state.selectedElement]=text; this.setState({optionalOrder:opt})      }}  />

                      <TextPresentation textExplicationSmall={strings.optionPicture} editable={false} text={(this.state.optionalOrder[rowData].picture!=undefined)?( (this.state.optionalOrder[rowData].picture.name.length>15)?(this.state.optionalOrder[rowData].picture.name.slice(0,8)+"[...]"+this.state.optionalOrder[rowData].picture.name.slice(this.state.optionalOrder[rowData].picture.name.length-4, this.state.optionalOrder[rowData].picture.name.length)) :this.state.optionalOrder[rowData].picture.name):strings.noPicture} textExplication={strings.picture} choosePicture={(picture)=>{  var opt=this.state.optionalOrder;  opt[rowData].notSaved=true; opt[rowData].changePicture=true;  opt[rowData].picture=picture; this.setState({optionalOrder:opt})  }} />



                      <TextPresentation textExplicationSmall={strings.definePriceOption} text={(this.state.optionalOrder[rowData].price!=undefined && this.state.optionalOrder[rowData].price[this.state.money.id]!=undefined)?this.state.optionalOrder[rowData].price[this.state.money.id].toString():""} textExplication={strings.price+" ("+this.state.money.symbole+")"} placeholder={((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+"2"+((this.state.money.position=="right")?(this.state.money.symbole):"")} chooseMoney={(this.state.moneyList.length>1)?true:undefined} moneyLimited={this.state.moneyList} money={this.state.money} flagMoney={this.state.money.flag} onChangeMoney={(value)=>{   this.setState({money:value}) }}  onChangeText={(text)=>{  var opt=this.state.optionalOrder; if(opt[rowData].price==undefined) opt[rowData].price={}; opt[rowData].notSaved=true; opt[rowData].price[this.state.money.id]=text; this.setState({optionalOrder:opt})      }}   />


                      {(this.state.optionalOrder[rowData].price!=undefined && this.state.optionalOrder[rowData].price[this.state.money.id]!=undefined && this.state.optionalOrder[rowData].price[this.state.money.id]!="") && <TextPresentation textRight={strings.modify} forceClick={()=>{ this.viewRepartition(rowData) }} onTextRightClick={()=>{ this.viewRepartition(rowData) }}  text={ (this.state.optionalOrder[rowData].repartition==undefined)?strings.priceShare:( (this.state.optionalOrder[rowData].repartition=="forDriver")?strings.forDriver:strings.forPlatform ) }  textExplication={strings.repartition} textExplicationSmall={strings.repartitionOptionsMoreInfo} editable={false} />}








                      <TextPresentation selectedQuantity={(this.state.optionalOrder[rowData].quantity!=undefined)?this.state.optionalOrder[rowData].quantity:1} onChangeQuantity={(quantity)=>{ var opt=this.state.optionalOrder; if(opt[rowData].quantity==undefined) opt[rowData].quantity=1; opt[rowData].notSaved=true; if(quantity==-1 && opt[rowData].quantity>1) opt[rowData].quantity--; else if(quantity==1) opt[rowData].quantity++; this.setState({optionalOrder:opt})  }}  textExplication={strings.quantity } textExplicationSmall={strings.quantityOption} editable={false}   />


                      <TextPresentation textRight={strings.modify} forceClick={()=>{ this.viewCarList(rowData) }} onTextRightClick={()=>{ this.viewCarList(rowData) }}  text={ ((Object.keys(this.state.carList).map((rowDataC) => ( (this.state.optionalOrder[rowData].carList!=undefined && this.state.optionalOrder[rowData].carList[rowDataC]==true)?"true":"false" ))).toString().search("true") !=-1)?(Object.keys(this.state.carList).map((rowDataC) => ( (this.state.optionalOrder[rowData].carList!=undefined && this.state.optionalOrder[rowData].carList[rowDataC]==true)?(rowDataC+"\n"):"" ))):(strings.noCarDefined+"\n")}  textExplication={strings.cars} textExplicationSmall={strings.targetCarMoreInfo} editable={false} />

                      {(this.state.vipMode===true) && <TextPresentation style={{marginTop:-20}} textRight={strings.modify} forceClick={()=>{ this.viewTarget(rowData) }} onTextRightClick={()=>{ this.viewTarget(rowData) }}  text={(this.state.optionalOrder[rowData].onlyAdmin==true)?(strings.onlyAdmin+"\n"): ((this.state.optionalOrder[rowData].target==undefined || (this.state.optionalOrder[rowData].target.standard==true && this.state.optionalOrder[rowData].target.vip==true && this.state.optionalOrder[rowData].target.pro==true))?(strings.all+"\n"):( ((this.state.optionalOrder[rowData].target.standard==true)?(strings.standard+"\n"):"")+((this.state.optionalOrder[rowData].target.vip==true)?(strings.vip+"\n"):"")+((this.state.optionalOrder[rowData].target.pro==true)?(strings.pro+"\n"):"")  ))}  textExplication={strings.target} textExplicationSmall={strings.selectUsersOption} editable={false} />}
                      {(this.state.vipMode===false) && <TextPresentation style={{marginTop:-20}} textRight={strings.modify} forceClick={()=>{ this.viewTarget(rowData) }} onTextRightClick={()=>{ this.viewTarget(rowData) }}  text={(this.state.optionalOrder[rowData].onlyAdmin==true)?(strings.onlyAdmin+"\n"):(strings.all+"\n") }  textExplication={strings.target} textExplicationSmall={strings.selectUsersOption} editable={false} />}


                      <View style={{flexDirection:"row", alignItems:"center", justifyContent:"center"}}>
                          {this.state.optionalOrder[rowData].index!=undefined && <MavMiniButton color={"orange"}  maximize={true} icon={(style.mode=="dark")?require('../assets/back_black.png'):require('../assets/back_white.png')} text={strings.cancel} onlyButton={true}  onPress={()=>{ this['viewOption_' + i].close(); var opt=this.state.optionalOrder; opt[rowData]=JSON.parse(JSON.stringify(this.state.optionalOrderSave[rowData])); this.setState({optionalOrder:opt})     }} />}
                          <MavMiniButton style={{marginLeft:(this.state.optionalOrder[rowData].index!=undefined)?12:undefined, marginRight:12}} color={style.colorValidate} maximize={true} icon={(style.mode=="dark")?require('../assets/checkBasic_black.png'):require('../assets/checkBasic_white.png')} text={strings.validate} onlyButton={true}  onPress={()=>{ this.updateOption(rowData,i);    }} />
                          <MavMiniButton color={style.colorNotification} maximize={true} icon={(style.mode=="dark")?require('../assets/close_black.png'):require('../assets/close_white.png')} text={strings.remove} onlyButton={true}  onPress={()=>{ this.removeOption(rowData,i);  }} />

                      </View>



                 
                </TextPresentation>
            ))}  




        </View>}  





                  


         {(this.state.viewAdmin!=true && this.state.optionalOrder!=undefined && this.state.addOptionSelected!=true) && <View style={{alignItems:"center",justifyContent:"center", marginTop:Dimensions.get('window').height * 0.05,marginBottom:Dimensions.get('window').height * 0.05}}>
              <MavButton text={strings.add} onlyButton={true} onPress={()=>{ var opt=JSON.parse(JSON.stringify(this.state.optionalOrder)); opt[generateUUID()]={name:{},price:{},carList:{}, description:{}, quantity:1  }; this.setState({addOptionSelected:true, optionalOrder:opt, selectedElement:"fr",},() =>{this['viewOption_' + (Object.keys(opt).length-1)].open(); })  }}/>
         </View>}

         {this.state.addOptionSelected==true && <View style={{width:50, height:50}} />}


          {(this.state.viewCarMode==true) && <View>



            <TextPresentation icon={(style.mode=="dark")?require('../assets/favorite/pin_white.png'):require('../assets/favorite/pin_black.png')} text={strings.driverPosition} editable={false} defautVisible={true} >


              <TextPresentation textMini={strings.viewRealDriverForDriverMoreInfo}  onoff={this.state.viewRealDriverForDriver} onOnOff={()=>{ var params=(this.props.route!=undefined)?this.props.route.params:this.props.params; params.updateViewRealDriverForDriver(!this.state.viewRealDriverForDriver); this.setState({viewRealDriverForDriver:!this.state.viewRealDriverForDriver}); }}  text={strings.viewRealDriverForDriver} editable={false}   />

              <TextPresentation textMini={(this.state.viewRealDriverForDriver==true)?strings.positionViewClient:strings.positionViewClientAdmin}  onoff={this.state.viewRealDriver} onOnOff={()=>{ var params=(this.props.route!=undefined)?this.props.route.params:this.props.params; params.updateViewRealDriver(!this.state.viewRealDriver) ; this.setState({viewRealDriver:!this.state.viewRealDriver}) ; }}  text={strings.viewRealDriver} editable={false}   />

              {this.state.viewRealDriver===true && <TextPresentation textMini={strings.driverPositionPreciseWarning}  onoff={this.state.driverPositionPrecise} onOnOff={()=>{ var params=(this.props.route!=undefined)?this.props.route.params:this.props.params;params.updateDriverPositionPrecise(!this.state.driverPositionPrecise) ; this.setState({driverPositionPrecise:!this.state.driverPositionPrecise})  }}  text={strings.driverPositionPrecise} editable={false}   />}

              {this.state.viewRealDriver===true && <TextPresentation textMini={strings.hideOtherCarIfRaceInProgressMoreInfo}  onoff={this.state.hideOtherCarIfRaceInProgress} onOnOff={()=>{ var params=(this.props.route!=undefined)?this.props.route.params:this.props.params;params.updateHideOtherCarIfRaceInProgress(!this.state.hideOtherCarIfRaceInProgress); this.setState({hideOtherCarIfRaceInProgress:!this.state.hideOtherCarIfRaceInProgress})  }}  text={strings.hideOtherCarIfRaceInProgress} editable={false}   />}


            </TextPresentation>


            <TextPresentation style={{marginTop:20}} explicationChild={strings.carColorMoreInfo} icon={require('../assets/pinMulticolor.png')} text={strings.carColor} editable={false} defautVisible={true} >

              
              <View style={{marginTop:20, width:"90%", marginLeft:"5%", marginRight:"5%", flexDirection: 'row',justifyContent: 'space-between', }}>
                    <View style={{alignItems:"center",width:"25%",}}>
                      <Image source={require('../assets/car.png')} style={{height: 60,width:60,resizeMode:"contain", }}/>
                      <Text style={{fontSize: style.textInputFontSize*0.75, color:style.textInputColor,  marginTop:5, textAlign:"center"}}>{strings.byDefault}</Text>
                    </View>


                    <View style={{alignItems:"center",width:"25%",}}>
                      <View style={{height: 60,width:60,}}>
                        <Image source={require('../assets/car.png')} style={{position:"absolute",height: 60,width:60,resizeMode:"contain", }}/>
                        {(this.state.carDriverColor!="" && Platform.OS=="web") && <View style={{position:"absolute",marginLeft:20, width:20, height:60, backgroundColor:this.state.carDriverColor}}/>}
                        {(this.state.carDriverColor!="" && Platform.OS!="web") && <Image source={require('../assets/car.png')} style={{position:"absolute",tintColor: this.state.carDriverColor,height: 60,width:60,resizeMode:"contain", }}/>}
                      </View>

                      <Text style={{fontSize: style.textInputFontSize*0.75,color:style.textInputColor, marginTop:5, marginBottom:5, textAlign:"center"}}>{strings.carDriver}</Text>
                      
                      <MavButton onlyButton={true} small={true}  text={strings.modify} style={{}} onPress={()=>{ 
                            var oldColor="";
                            if(this.state.carDriverColor!=""){
                              oldColor=this.state.carDriverColor
                              if(this.state.carDriverColor[0]=="r"){
                                oldColor=oldColor.replace('rgba(','')
                                oldColor=oldColor.replace(')','')
                                oldColor=oldColor.split(",");
                                oldColor="#"+((parseInt(oldColor[0])<16)?"0":"")+parseInt(oldColor[0]).toString(16) +((parseInt(oldColor[1])<16)?"0":"")+parseInt(oldColor[1]).toString(16)+((parseInt(oldColor[2])<16)?"0":"")+parseInt(oldColor[2]).toString(16)
                              } 
                            }
                            this.setState({colorSelected:"carDriverColor"}); 
                            this.alert.onAlert({title:strings.selectColor, subTitle:strings.explicationHexaColor,  choiceColor:true, textInput:{text:oldColor,sizeMultiplicator:1.5,placeholder:"(ex : #FF0000)"}, help:{title:strings.selectColor, subTitle:strings.explicationHexaColorMoreInfo, url:"https://fr.wikipedia.org/wiki/Couleur_du_Web" },buttons:[{text: strings.validate,onPress: (value) => { this.updateColor(value) }}, {text: strings.cancel, style:"cancel",onPress: () => {}}],})

                               
                       }}/>

                      <MavButton onlyButton={true} small={true} strokeMode={true} text={strings.remove} style={{marginTop:5}} onPress={()=>{ this.setState({carDriverColor:""});var params=(this.props.route!=undefined)?this.props.route.params:this.props.params; params.updateColorDriver("carDriverColor","")}}/>


                    </View>
                    <View style={{alignItems:"center",width:"25%",}}>
                      <View style={{height: 60,width:60,}}>
                        <Image source={require('../assets/car.png')} style={{position:"absolute",height: 60,width:60,resizeMode:"contain", }}/>
                        {(this.state.driverApproachingColor!="" && Platform.OS=="web") && <View style={{position:"absolute",marginLeft:20, width:20, height:60, backgroundColor:this.state.driverApproachingColor}}/>}
                        {(this.state.driverApproachingColor!="" && Platform.OS!="web") && <Image source={require('../assets/car.png')} style={{position:"absolute",tintColor: this.state.driverApproachingColor,height: 60,width:60,resizeMode:"contain", }}/>}
                      </View>

                      <Text style={{fontSize: style.textInputFontSize*0.75,color:style.textInputColor, marginTop:5, marginBottom:5, textAlign:"center"}}>{strings.driverApproaching}</Text>
                      
                      <MavButton onlyButton={true} small={true}  text={strings.modify} style={{}} onPress={()=>{ 
                            var oldColor="";
                            if(this.state.driverApproachingColor!=""){
                              oldColor=this.state.driverApproachingColor
                              if(this.state.driverApproachingColor[0]=="r"){
                                oldColor=oldColor.replace('rgba(','')
                                oldColor=oldColor.replace(')','')
                                oldColor=oldColor.split(",");
                                oldColor="#"+((parseInt(oldColor[0])<16)?"0":"")+parseInt(oldColor[0]).toString(16) +((parseInt(oldColor[1])<16)?"0":"")+parseInt(oldColor[1]).toString(16)+((parseInt(oldColor[2])<16)?"0":"")+parseInt(oldColor[2]).toString(16)
                              } 
                            }
                            this.setState({colorSelected:"driverApproachingColor"}); 
                            this.alert.onAlert({title:strings.selectColor, subTitle:strings.explicationHexaColor,  choiceColor:true, textInput:{text:oldColor,sizeMultiplicator:1.5,placeholder:"(ex : #FF0000)"}, help:{title:strings.selectColor, subTitle:strings.explicationHexaColorMoreInfo, url:"https://fr.wikipedia.org/wiki/Couleur_du_Web" },buttons:[{text: strings.validate,onPress: (value) => { this.updateColor(value) }}, {text: strings.cancel, style:"cancel",onPress: () => {}}],})

                       }}/>

                      <MavButton onlyButton={true} small={true} strokeMode={true} text={strings.remove} style={{marginTop:5}} onPress={()=>{ this.setState({driverApproachingColor:""});var params=(this.props.route!=undefined)?this.props.route.params:this.props.params; params.updateColorDriver("driverApproachingColor","")}}/>


                    </View>

                </View>


            </TextPresentation>


            <TextPresentation style={{marginTop:20}} explicationChild={strings.seenFromAboveMoreInfo} icon={require('../assets/car.png')} text={strings.seenFromAbove} editable={false} defautVisible={true} >
 
  
                {Object.keys(this.state.carList).map((rowData) => (

                  <View>
                    <View style={{width:"80%", marginLeft:"10%", marginRight:"10%",flexDirection: 'row',alignItems:"center", height:60,justifyContent: 'space-between',}}>
                        <Text style={{fontSize: style.textInputFontSize, color:style.textInputColor, width:"30%"}}>{rowData}</Text>
                        <Image source={(this.state.picturesCar.carUsed!=undefined && this.state.picturesCar.carUsed[rowData]!=undefined && this.state.picturesCar.carUsed[rowData].aboveSource!=undefined)?this.state.picturesCar.carUsed[rowData].aboveSource:   require('../assets/car.png')} style={{transform: [{rotate:"90deg"}], height: 60,width:60,resizeMode:"contain", }}/>
                        <MavButton onlyButton={true} small={true} text={strings.modify} style={{marginTop:5}} onPress={()=>{ this.setState({viewAboveCar:true, selectedAboveCar:rowData   });}}/>


                    </View>
                    <View style={{height: style.textLineHeight,backgroundColor: style.textInputLineColor,marginTop: style.textInputMarginTop,marginLeft:"10%",marginRight:"10%",}}/>

                  </View>

                         
                    ))}

            </TextPresentation>


            <View style={{width:50, height:50}}/>


                


          </View>}

          <Modal animationType="none" transparent={true} visible={this.state.viewAboveCar}>
            <View style={{height:Dimensions.get('window').height,width:Dimensions.get('window').width,position:"absolute", backgroundColor:style.backgroundColor, alignItems:"center"}}>
                 <Text style={{fontSize: style.textInputFontSize*1.5, color:style.textInputColor,textAlign:"center",marginTop:50,marginRight:"10%", marginLeft:"10%"}}>{strings.pictureAvaiable}</Text>
                 <Text style={{fontSize: style.textInputFontSize*0.9, color:style.textInputColor,textAlign:"center",marginTop:5,marginBottom:10,marginRight:"10%", marginLeft:"10%"}}>{strings.pictureAvaiableAboveMoreInfo}</Text>
                   <FlatList
                      data={Object.keys(this.state.picturesCar.carAvailable)}
                      renderItem={({ item }) => (
                        <View style={{ width:Dimensions.get('window').width*0.2,}}>

                            <TouchableHighlight underlayColor={'rgba(255,255,255,0)'} onPress={() => { this.updatePictureCar({type:"modifyAboveCar",uuidCar:item }) ; this.setState({viewAboveCar:false})    }} ><View> 
                                <Image source={this.state.picturesCar.carAvailable[item].source} style={{height: Dimensions.get('window').width*0.2,width:Dimensions.get('window').width*0.2,resizeMode:"contain", }}/>
                                {(( (this.state.picturesCar.carUsed==undefined || this.state.picturesCar.carUsed[this.state.selectedAboveCar]==undefined || this.state.picturesCar.carUsed[this.state.selectedAboveCar].above==undefined) && item=="default") || (this.state.picturesCar.carUsed!=undefined && this.state.picturesCar.carUsed[this.state.selectedAboveCar]!=undefined &&  this.state.picturesCar.carUsed[this.state.selectedAboveCar].above==item)) && <View style={{opacity:0.5,backgroundColor:style.backgroundColor,height:Dimensions.get('window').width*0.2,width:Dimensions.get('window').width*0.2, position:"absolute", alignItems:"center",justifyContent:"center",}}/>}
                                

                                {(( (this.state.picturesCar.carUsed==undefined || this.state.picturesCar.carUsed[this.state.selectedAboveCar]==undefined || this.state.picturesCar.carUsed[this.state.selectedAboveCar].above==undefined) && item=="default") || (this.state.picturesCar.carUsed!=undefined && this.state.picturesCar.carUsed[this.state.selectedAboveCar]!=undefined && this.state.picturesCar.carUsed[this.state.selectedAboveCar].above==item)) && <View style={{height:Dimensions.get('window').width*0.2,width:Dimensions.get('window').width*0.2, position:"absolute", alignItems:"center",justifyContent:"center",}}>
                                    <Text style={{fontSize: style.textInputFontSize*3,color:style.colorValidate}}>✓</Text>
                                </View>}
                            </View></TouchableHighlight>
                          
                        </View>
                      )}
                      
                      numColumns={4}
                      keyExtractor={(item, index) => index}
                    />

                    <View style={{alignItems:"center",justifyContent:"center",marginTop:10}}>
                          {(this.state.loadPicture!=true && Platform.OS!="web") && <MavButton text={strings.add} onlyButton={true} style={{marginTop:20}} onPress={()=>{this.takePicture() }}/>}
                          {this.state.loadPicture==true && <ActivityIndicator style={{marginTop:10}} size="large" color={style.color1} />}

                          <MavButton text={strings.close} onlyButton={true} strokeMode={true} style={{marginTop:10, marginBottom:50}} onPress={()=>{ 
                                this.setState({viewAboveCar:false})
                             }}/>


                        </View>



            </View>
          </Modal>

          

             <MavAlert ref={alert => {this.alert = alert;}}/>

      </ScrollView>

      }</StyleContext.Consumer>
    );
  }
}

account.navigationOptions = ({ navigation, screenProps }) => {
  return {
    headerTitle: strings.proposeOtherOptions,
    headerTintColor: screenProps.headerColor,
    headerStyle: {
      backgroundColor: screenProps.headerBackgroundColor,
    },
  };
};


export function generateUUID() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}
